document.addEventListener("DOMContentLoaded", () => {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    // Delegación de eventos
    document.body.addEventListener("click", async (e) => {
        const btn = e.target.closest("button");
        if (!btn) return;
        const action = btn.dataset.action;
        if (!action) return;

        try {
            switch(action) {
                case "accept":
                    await postAction(`/reconciliations/${btn.dataset.type}/matches/${btn.dataset.index}/accept`);
                    removeRowAndRefresh(btn.dataset.type, btn.dataset.index);
                    break;

                case "deny":
                    await postAction(`/reconciliations/${btn.dataset.type}/matches/${btn.dataset.index}/deny`);
                    removeRowAndRefresh(btn.dataset.type, btn.dataset.index);
                    break;

                case "accept-all":
                    await postAction(`/reconciliations/${btn.dataset.type}/matches/accept_all`);
                    // recargar la sección de matches
                    reloadMatchesSection(btn.dataset.type);
                    break;

                // case "open-modal":
                //     openModal(btn.dataset.type, btn.dataset.which, 1);
                //     break;

                case "modal-accept":
                    await postAction(`/reconciliations/${btn.dataset.type}/solo_en_sistema/${btn.dataset.index}/accept`);
                    // recargar modal y matches
                    openModal(btn.dataset.type, 'solo_en_sistema', 1);
                    reloadMatchesSection(btn.dataset.type);
                    break;

                case "change-page":
                    // recargar matches con page param
                    reloadMatchesSection(btn.dataset.type, btn.dataset.page);
                    break;

                case "modal-change-page":
                    openModal(btn.dataset.type, btn.dataset.which, btn.dataset.page);
                    break;

                case "close-modal":
                    // quitar modal del DOM
                    const modal = btn.closest(".modal");
                    if (modal) modal.remove();
                    break;
            }
        } catch (err) {
            alert("Ocurrió un error: " + (err.message || err));
            console.error(err);
        }
    });

    async function postAction(path) {
        const resp = await fetch(path, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": csrfToken,
                "Accept": "application/json"
            },
            body: JSON.stringify({})
        });
        if (!resp.ok) {
            const data = await resp.json().catch(()=>({}));
            throw new Error(data.error || resp.statusText);
        }
        return resp.json();
    }

    function removeRowAndRefresh(tipo, index) {
        // remover row visualmente y recargar la sección paginada para mantener índices en sincronía
        const row = document.getElementById(`${tipo}_match_row_${index}`);
        if (row) row.remove();
        // recargar matches section para refrescar indices y paginación
        reloadMatchesSection(tipo);
    }

    async function reloadMatchesSection(tipo, page = 1) {
        // pedir la página de results (re-render parcial de matches)
        const params = new URLSearchParams({ ["page_"+tipo]: page, per_page: 25 });
        const resp = await fetch(`/reconciliations/results?${params.toString()}`, {
            headers: { "Accept": "text/html" }
        });
        const text = await resp.text();
        // parsear y reemplazar la sección correspondiente
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");
        const container = doc.getElementById(`${tipo}_matches_container`);
        if (container) {
            const current = document.getElementById(`${tipo}_matches_container`);
            if (current) current.replaceWith(container);
        } else {
            // si no vino la sección, recargar la página completa
            window.location.reload();
        }
    }

    function openModal(type, which, title = null, page = 1) {
        const modalEl = document.getElementById("dynamicModal");
        const modalBody = modalEl.querySelector("#modalBody");
        const modalTitle = modalEl.querySelector("#modalTitle");

        modalTitle.textContent = title || `${type.toUpperCase()} - ${which}`;
        modalBody.innerHTML = "<div class='text-center py-4'>Cargando...</div>";

        fetch(`/reconciliations/modal_list?type=${type}&which=${which}&page=${page}`)
            .then(response => {
                if (!response.ok) throw new Error("Error al cargar contenido del modal");
                return response.text();
            })
            .then(html => {
                modalBody.innerHTML = html;

                // mostrar modal solo después de insertar contenido
                const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
                modal.show();
            })
            .catch(error => {
                console.error(error);
                modalBody.innerHTML = "<div class='text-danger text-center py-3'>Error al cargar datos.</div>";
                const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
                modal.show();
            });
    }

// Si tienes botones internos en los modales (por ejemplo paginación AJAX)
    function initializeModalEvents(modalBody) {
        modalBody.querySelectorAll(".pagination a").forEach(link => {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                fetch(this.href)
                    .then(r => r.text())
                    .then(html => {
                        modalBody.innerHTML = html;
                        initializeModalEvents(modalBody);
                    });
            });
        });
    }

    window.openModal = openModal;
});